var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var _a;
import { css } from 'styled-components';
export var Sizes;
(function (Sizes) {
  /** * @deprecated use only DESKTOP / TABLET / MOBILE_LARGE */
  Sizes["HD"] = "hd";
  Sizes["DESKTOP"] = "desktop";
  Sizes["TABLET"] = "tablet";
  Sizes["MOBILE_LARGE"] = "mobileLarge";
  /** * @deprecated use only DESKTOP / TABLET / MOBILE_LARGE */
  Sizes["MOBILE_LANDSCAPE"] = "mobileLandscape";
})(Sizes || (Sizes = {}));
export var sizes = (_a = {}, /** * @deprecated use only DESKTOP / TABLET / MOBILE_LARGE */
_a[Sizes.HD] = 1200, _a[Sizes.DESKTOP] = 992, _a[Sizes.TABLET] = 768, _a[Sizes.MOBILE_LARGE] = 576, /** * @deprecated use only DESKTOP / TABLET / MOBILE_LARGE */
_a[Sizes.MOBILE_LANDSCAPE] = 360, _a);
var NEW_SIZES = {
  sm: sizes[Sizes.MOBILE_LARGE],
  md: sizes[Sizes.TABLET],
  lg: sizes[Sizes.DESKTOP]
};
var pixelsToEm = function (px) {
  return "".concat(px / 16, "em");
};
export var screenSizes = function (label) {
  return pixelsToEm(sizes[label]);
};
export function fromSize(bp) {
  // prettier-ignore
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media screen and (min-width: ", ")\n  "], ["\n    @media screen and (min-width: ", ")\n  "])), pixelsToEm(NEW_SIZES[bp]));
}
var templateObject_1;